import styled, { css } from "styled-components";
import { breakpoints } from "../../../../../shared-logic/themes/lexusTheme";

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    padding-top: var(--spacing-5);
    gap: var(--spacing-1);
`;

/* Toggle */
export const Toggle = styled.div`
    display: flex;
    flex-direction: row;
    margin: var(--spacing-3) 0 var(--spacing-4);
    padding: var(--spacing-1);
    background-color: var(--color-grey-4);
    border: 2px solid transparent;
    border-radius: 8px;
`;

export const ToggleButton = styled.button`
    display: flex;
    flex: 1 0 50%;
    flex-direction: column;
    align-items: center;
    padding: calc(var(--spacing-3) / 2) var(--spacing-2);
    text-align: center;
    border: 0;
    border-radius: 4px;
    user-select: none;
    &[aria-pressed="true"] {
        color: var(--color-primary-black);
        background-color: var(--color-primary-white);
        box-shadow: var(--dropshadow-md);
    }
`;
export const ButtonTitle = styled.span`
    margin-top: auto;
    font-family: var(--font-semi-bold);
    font-size: 1.6rem;
    line-height: 2.4rem;
`;

/* Map */
export const MapWrapper = styled.div`
    position: relative;
    flex-grow: 1;
    width: 100%;
    aspect-ratio: 3/4;
    @media screen and (min-width: ${breakpoints.sm}) {
        aspect-ratio: 1;
    }
    @media screen and (min-width: ${breakpoints.md}) {
        aspect-ratio: 11/6;
    }
`;

export const Map = styled.div`
    position: absolute;
    inset: 0;
    .mapboxgl-map {
        width: 100%;
        height: 100%;
        border-radius: 4px;
    }
`;

export const Loader = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%);
`;

export const SelectWrapper = styled.div`
    position: absolute;
    top: var(--spacing-5);
    inset-inline: var(--spacing-1);

    @media screen and (min-width: ${breakpoints.md}) {
        inset-inline: var(--spacing-5);
    }
`;

export const InputWrapper = styled.div<{ open?: boolean }>`
    display: flex;
    position: relative;
    justify-content: space-between;
    background: var(--color-primary-white);
    border-radius: 4px;
    box-shadow: var(--dropshadow-md);
    z-index: 2;
    ${({ open }) =>
        open &&
        css`
            border-radius: 4px 4px 0 0;
            box-shadow: none;
        `};
    input {
        width: 100%;
        padding: var(--spacing-2) var(--spacing-3);
        background: transparent;
        border: none;
    }
`;

export const InputAppend = styled.div`
    display: flex;
    padding-inline-end: var(--spacing-3);
    > * {
        margin-inline-start: var(--spacing-1);
    }
`;

export const CarLocationResults = styled.div`
    display: block;
    position: absolute;
    top: 100%;
    inset-inline: 0;
    max-height: 250px;
    background-color: var(--color-primary-white);
    border-radius: 0 0 4px 4px;
    overflow-y: auto;
    box-shadow: var(--dropshadow-md);

    ul {
        display: block;
        margin: 0;
        padding: 0;
    }

    li {
        display: flex;
        align-items: center;
        gap: var(--spacing-1);
        margin: 0;
        padding: 12px;
        font-size: 1.6rem;
        line-height: 2.4rem;
        cursor: pointer;

        &:not(:last-child) {
            border-bottom: 1px solid var(--color-grey-4);
        }
    }
`;

export const NoResultsErrorMessage = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 44px;
    text-align: center;
    color: var(--color-grey-7);
    background: var(--color-primary-white);
    border-top: 1px solid var(--color-grey-1);
`;
